import { RootState } from "../..";

export const selectList = (state: RootState) => state.events.data.list;

export const selectListPagination = (state: RootState) =>
  state.events.pagination.list;

export const selectIsListLoading = (state: RootState) =>
  state.events.loading.list;
